import { render, staticRenderFns } from "./DpApplicationPhotoField.vue?vue&type=template&id=3c87f9a3&scoped=true&"
import script from "./DpApplicationPhotoField.vue?vue&type=script&lang=js&"
export * from "./DpApplicationPhotoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c87f9a3",
  null
  
)

export default component.exports